import { v4 as uuidv4 } from 'uuid';

/**
 * 요청마다 유니크한 Trace Id를 생성합니다.
 */
export function getTraceId() {
  return uuidv4();
}
